var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.59 480C158.286 480 103.579 456.438 62.537 413.656C20.846 370.188 0 313.094 0 256C0 198.906 20.846 141.813 62.537 98.344C103.579 55.562 158.286 32 216.59 32S329.6 55.562 370.643 98.344C388.998 117.5 388.357 147.875 369.204 166.219C350.036 184.5 319.625 183.938 301.285 164.781C255.787 117.344 177.361 117.344 131.894 164.781C83.644 215.094 83.644 296.906 131.894 347.219C177.361 394.656 255.787 394.656 301.285 347.219C319.625 328.063 350.036 327.438 369.204 345.781C388.357 364.125 388.998 394.5 370.643 413.656C329.6 456.438 274.893 480 216.59 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.7b58e5fe31b47b732b523fd83a861be0.svg";
export { ForwardRef as ReactComponent };